var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page-footer footer-c-height", attrs: { align: "center" } },
    [
      _c("div", { staticClass: "page-footer-inner" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("div", [
          _vm._v(
            "Copyright © 2007 -\n      " +
              _vm._s(_vm.getCurrentYear()) +
              " Buy1Give1 Pte Ltd/B1G1 Giving Inc (Singapore)\n    "
          )
        ])
      ])
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "footer-links" }, [
      _c("label", { staticStyle: { "font-weight": "700" } }, [
        _vm._v("Useful Links:")
      ]),
      _vm._v(" "),
      _c("a", { attrs: { href: "http://www.awesome.dev", target: "_blank" } }, [
        _vm._v("Main\n      B1G1 Site")
      ]),
      _vm._v(" | "),
      _c("a", { attrs: { href: "#", target: "_blank" } }, [_vm._v("WC Login")]),
      _vm._v(" | "),
      _c("a", { attrs: { href: "#", target: "_blank" } }, [
        _vm._v("WordPress Login")
      ]),
      _vm._v(" |\n      "),
      _c("a", { attrs: { href: "#", target: "_blank" } }, [
        _vm._v("Google Analytics")
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ea3ad9ea", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ea3ad9ea","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/Footer.vue
// module id = null
// module chunks = 